import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DealCard } from "@/components/site/DealCard";
import { SectionHead } from "@/components/site/Reveal";

export default function CompletedDeals() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/deals").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 sm:py-20" data-testid="completed-page">
      <SectionHead eyebrow="Track record" title="Completed deals">
        Real sales we've brought together between chain-free buyers and motivated sellers.
      </SectionHead>
      {items === null ? (
        <p className="mt-16 eyebrow">Loading…</p>
      ) : items.length === 0 ? (
        <p className="mt-16 text-[#57534E]" data-testid="deals-empty">Completed deals will appear here soon.</p>
      ) : (
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((d) => <DealCard key={d.id} d={d} />)}</div>
      )}
    </div>
  );
}
